export * from './tick-circle.icon';
